import Vue from 'vue';
import { State } from '@/stores/quotes/state';
import { MutationTree } from 'vuex';
import { Quote } from '@/models/quote';

export class Mutations implements MutationTree<State> {
    [key: string]: (state: State, payload: any) => any;

    public setAllQuotes = (state: State, Quotes: Array<Quote>) => {
        state.allQuotes = Quotes;
    }
    public setAllQuotesPage = (state: State, page: number) => {
        state.allQuotesPageNumber = page;
    }
    public setAllQuotesCurrentPageSize = (state: State, pageSize: number) => {
        state.allQuotesPageSize = pageSize;
    }
    public setAllQuotesTotalPages = (state: State, pageCount: number) => {
        state.allQuotesTotalPages = pageCount;
    }
    public setAllQuotesTotal = (state: State, totalRecords: number) => {
        state.allQuotesTotal = totalRecords;
    }
    public setAllQuotesFilterStatus = (state: State, filterStatus: number | string | null) => {
        state.allQuotesFilterStatus = filterStatus;
    }
    public setAllQuotesFrom = (state: State, from: string | null) => {
        state.allQuotesFrom = from;
    }
    public setAllQuotesTo = (state: State, to: string | null) => {
        state.allQuotesTo = to;
    }
}
